import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="clipboard" id="clipboard"></a>
    <h1 {...{
      "id": "navigatorclipboard"
    }}>{`navigator.clipboard`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Clipboard"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Clipboard`}</a>{`  `}</p>
    <a name="new-clipboard-new" id="new-clipboard-new"></a>
    <h2 {...{
      "id": "clipboard"
    }}>{`Clipboard()`}</h2>
    <p>{`Creates an instance of Clipboard.`}</p>
    <p>{`Note: Clipboard access is not supported for 3P plugins with manifest version upto 4. Valid manifest entry required from manifest version 5.;`}</p>
    <a name="clipboard-setcontent" id="clipboard-setcontent"></a>
    <h2 {...{
      "id": "setcontentdata"
    }}>{`setContent(data)`}</h2>
    <p>{`Set data to clipboard.
Note: This is a non-standard API.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The data to store in the clipboard. The object keys are the mime types, so for text, use `}<inlineCode parentName="td">{`text/plain`}</inlineCode>{` as a key.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`navigator.clipboard.setContent({"text/plain": "Hello!"});
`}</code></pre>
    <a name="clipboard-getcontent" id="clipboard-getcontent"></a>
    <h2 {...{
      "id": "getcontent"
    }}>{`getContent()`}</h2>
    <p>{`Get data from clipboard.
Note: This is a non-standard API.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`navigator.clipboard.getContent();
`}</code></pre>
    <a name="clipboard-write" id="clipboard-write"></a>
    <h2 {...{
      "id": "writedata"
    }}>{`write(data)`}</h2>
    <p>{`Write data to clipboard. This can be used to implement cut and copy functionality.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/write"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/write`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v6.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The data to set.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`navigator.clipboard.write({"text/plain": "Hello!"});
`}</code></pre>
    <a name="clipboard-writetext" id="clipboard-writetext"></a>
    <h2 {...{
      "id": "writetexttext"
    }}>{`writeText(text)`}</h2>
    <p>{`Write text to clipboard. This can be used to implement cut and copy text functionality.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v6.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`text string to set or an object of the form {"text/plain": "text to set"}.                               Note that the object format will be deprecated and shouldn't be used.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`navigator.clipboard.writeText("Hello!");
`}</code></pre>
    <a name="clipboard-read" id="clipboard-read"></a>
    <h2 {...{
      "id": "read"
    }}>{`read()`}</h2>
    <p>{`Read data from clipboard.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/read"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/read`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v6.0`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`navigator.clipboard.read();
`}</code></pre>
    <a name="clipboard-readtext" id="clipboard-readtext"></a>
    <h2 {...{
      "id": "readtext"
    }}>{`readText()`}</h2>
    <p>{`Read text from clipboard.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/readText"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/readText`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v6.0`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`navigator.clipboard.readText();
`}</code></pre>
    <a name="clipboard-clearcontent" id="clipboard-clearcontent"></a>
    <h2 {...{
      "id": "clearcontent"
    }}>{`clearContent()`}</h2>
    <p>{`Clear clipboard content.
Note: Nonstandard: This method is non-standard.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v6.0`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`navigator.clipboard.clearContent();
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      